import React from 'react';
import Form from '../form/Form';

const getLayout = (filter = {}) => {
  return [
    {
      name: 'customerId',
      label: 'Select Customer',
      toolbar: [{ action: 'add', pageName: 'EQS5' }],
      validation: {
        page: 'EQS5',
        type: 'customer',
        filter,
      },
      required: true,
      data: '',
    },
  ];
};

const PickCustomer = ({ onSubmit, filter }) => {
  return <div><Form layout={getLayout(filter)} submit={onSubmit} exportFormat="object" /></div>;
};

export default PickCustomer;
